/* HobbyChef — interaktivita (carousel, filtry, řazení) */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Ambasadoři: carousel ---- */
    document.querySelectorAll('.hc-amb').forEach(function (amb) {
      var row = amb.querySelector('.hc-amb__row');
      if (!row) return;
      var arrows = amb.querySelectorAll('.hc-amb__arrow');
      function step() {
        var card = row.querySelector('.hc-amb__card');
        return card ? card.getBoundingClientRect().width + 32 : 400;
      }
      if (arrows[0]) arrows[0].addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (arrows[1]) arrows[1].addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* Dráha místo teček: šířka = kolik z řady je vidět, posun = kde je. */
      var thumb = amb.querySelector('[data-hc-amb-thumb]');
      if (thumb) {
        var sync = function () {
          var total = row.scrollWidth;
          if (!total) return;
          thumb.style.width = Math.min(100, row.clientWidth / total * 100) + '%';
          thumb.style.left = row.scrollLeft / total * 100 + '%';
        };
        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        window.addEventListener('load', sync);
        sync();
      }

      /* ---- Tažení myší ----
         Řada je nativní vodorovný scroller, takže tažení stačí přepsat
         do scrollLeft. Pojistky, bez kterých to působí rozbitě:
           * jen levé tlačítko myši a jen pointerType 'mouse' — na dotyku
             si rolování řeší prohlížeč sám a dvojí obsluha by se prala,
           * preventDefault na pointerdown, jinak prohlížeč začne táhnout
             fotku jako obrázek a výběr textu,
           * scroll-behavior dočasně na auto: hobbychef.css má na řadě
             smooth kvůli šipkám a při tažení by se řada táhla se
             zpožděním za kurzorem,
           * kliknutí po tažení se zahazuje v capture fázi, jinak by
             puštění myši nad kartou otevřelo odkaz pod ní. */
      var dragging = false, startX = 0, startScroll = 0, moved = 0;

      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = 0;
        startX = e.clientX; startScroll = row.scrollLeft;
        try { row.setPointerCapture(e.pointerId); } catch (err) {}
        row.style.scrollBehavior = 'auto';
        amb.classList.add('is-dragging');
        e.preventDefault();
      });

      row.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        row.scrollLeft = startScroll - dx;
        /* Jezdec se jinak hne až se `scroll` událostí, tedy o snímek
           později než řada. Při tažení je to vidět. */
        if (thumb) sync();
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        amb.classList.remove('is-dragging');
        try { row.releasePointerCapture(e.pointerId); } catch (err) {}
        row.style.scrollBehavior = '';
      }
      row.addEventListener('pointerup', endDrag);
      row.addEventListener('pointercancel', endDrag);

      /* 5 px je práh, pod kterým je to ještě kliknutí, ne tažení. */
      row.addEventListener('click', function (e) {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);

    });


    /* ---- Hero slider ---- */
    document.querySelectorAll('[data-hc-slider]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-slide]');
      if (slides.length < 2) return;
      var dots = root.querySelectorAll('[data-slider-dot]');
      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      var i = 0, timer = null;
      var auto = parseInt(root.getAttribute('data-autoplay') || '0', 10);

      /* data-slider-off="(max-width: 767px)" slider v dané šířce vypne.
         Hero na mobilu má podle dohody z 28. 8. 2026 zůstat na první fotce;
         schovat tečky v CSS nestačí, protože autoplay by dál přepínal na
         slajd, který CSS skrylo, a pás by zůstal prázdný. Vyhodnocuje se
         živě, takže otočení telefonu nic nerozbije. */
      var offQuery = root.getAttribute('data-slider-off');
      var mq = offQuery && window.matchMedia ? window.matchMedia(offQuery) : null;
      function zapnuto() { return !(mq && mq.matches); }

      function go(n) {
        if (!zapnuto()) n = 0;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('hc-hphero__dot--active', k === i); });
      }
      function restart() {
        if (timer) clearInterval(timer);
        if (auto > 0 && zapnuto()) timer = setInterval(function () { go(i + 1); }, auto * 1000);
      }
      if (mq && mq.addEventListener) mq.addEventListener('change', function () { go(0); restart(); });
      if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      root.addEventListener('mouseleave', restart);
      restart();
    });

    /* ---- Video lightbox ---- */
    function toEmbed(u) {
      var m = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]+)/);
      if (m) return { type: 'iframe', src: 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1' };
      m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1' };
      if (/\.(mp4|webm|mov)(\?|$)/i.test(u)) return { type: 'video', src: u };
      return null;
    }
    document.querySelectorAll('.hc-video__play').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var url = btn.getAttribute('href') || '';
        var em = url && url !== '#' ? toEmbed(url) : null;
        if (!em) return;                 /* není video → nech normální odkaz */
        e.preventDefault();
        var ov = document.createElement('div');
        ov.className = 'hc-lightbox';
        var inner = em.type === 'iframe'
          ? '<iframe src="' + em.src + '" allow="autoplay; fullscreen" allowfullscreen frameborder="0"></iframe>'
          : '<video src="' + em.src + '" controls autoplay playsinline></video>';
        ov.innerHTML = '<button class="hc-lightbox__close" aria-label="Zavřít">&times;</button><div class="hc-lightbox__frame">' + inner + '</div>';
        document.body.appendChild(ov);
        document.body.style.overflow = 'hidden';
        function close() { ov.remove(); document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); }
        function onKey(ev) { if (ev.key === 'Escape') close(); }
        ov.addEventListener('click', function (ev) {
          if (ev.target === ov || ev.target.classList.contains('hc-lightbox__close')) close();
        });
        document.addEventListener('keydown', onKey);
      });
    });

    /* ---- Mega menu (klávesnice + dotyk; hover řeší CSS) ---- */
    document.querySelectorAll('.hc-mainnav__item--has-mega').forEach(function (li) {
      var link = li.querySelector('a');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: none)').matches) {
          if (!li.classList.contains('is-open')) { e.preventDefault(); }
          document.querySelectorAll('.hc-mainnav__item--has-mega.is-open').forEach(function (o) { if (o !== li) o.classList.remove('is-open'); });
          li.classList.toggle('is-open');
        }
      });
    });
    /* Panel stojí na středu položky. Na užším okně (1100–1400 px) by krajní
       panely vyjely ven — vpravo „Doplňky" až na 1336 px při šířce 1280,
       vlevo „Japonské nože" na −31 — a i skrytý panel dělal vodorovný
       posuvník. Posuneme ho dovnitř s odstupem 16 px od okraje. Počítá se
       z polohy položky a šířky panelu, ne z getBoundingClientRect panelu,
       aby výsledek nezávisel na rozběhnuté transition. */
    var megaItems = document.querySelectorAll('.hc-mainnav__item--has-mega');
    function fitMega() {
      var vw = document.documentElement.clientWidth, gap = 16;
      megaItems.forEach(function (li) {
        var mega = li.querySelector('.hc-mega');
        if (!mega) return;
        var r = li.getBoundingClientRect(), w = mega.offsetWidth;
        if (!w) return;   /* nav je schovaná (mobil) */
        var left = r.left + r.width / 2 - w / 2, dx = 0;
        if (left + w > vw - gap) dx = vw - gap - (left + w);
        if (left + dx < gap) dx = gap - left;
        if (dx) mega.style.setProperty('--hc-mega-dx', Math.round(dx) + 'px');
        else mega.style.removeProperty('--hc-mega-dx');
      });
    }
    if (megaItems.length) {
      fitMega();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMega);
      var megaRaf = 0;
      window.addEventListener('resize', function () {
        cancelAnimationFrame(megaRaf);
        megaRaf = requestAnimationFrame(fitMega);
      });
      megaItems.forEach(function (li) {
        li.addEventListener('mouseenter', fitMega);
        li.addEventListener('focusin', fitMega);
      });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hc-mainnav__item--has-mega')) {
        document.querySelectorAll('.hc-mainnav__item--has-mega.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });

    /* ---- Filtr: rozbalení panelu ---- */
    document.querySelectorAll('[data-hc-filter-toggle]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls') || 'hc-filter-panel');
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* ---- Filtry: auto-submit po změně ---- */
    document.querySelectorAll('form.hc-filterpanel, .hc-filters form').forEach(function (form) {
      form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (inp) {
        inp.addEventListener('change', function () { form.submit(); });
      });
    });
  });
})();
